// extracted by mini-css-extract-plugin
export default {"cls1":"SocialEditor-cls1___1ba272dd113fec2c46c","cls2":"SocialEditor-cls2__cf02c766376bcd15ef88 SocialEditor-cls1___1ba272dd113fec2c46c"};